/**
 * Canonical drill tag taxonomy — mirrors the heuristic logic meta tags.
 * Shared between PPA (Post Game Analysis), the Drill Library, and the Practice Plan Generator.
 */

export const DRILL_TAGS = [
  "Shooting Efficiency",
  "Shot Selection",
  "Rim Protection & Contesting",
  "Perimeter & Mid-Range Shooting",
  "Three-Point Shooting",
  "Perimeter Defense",
  "Finishing at the Rim",
  "Ball Handling & Decision-Making",
  "Turnovers & Ball Security",
  "Steals & On-Ball Pressure",
  "Offensive Rebounding",
  "Defensive Rebounding",
  "Attacking the Rim",
  "Drawing Contact & Fouls",
  "Free-Throw Consistency",
  "Foul Discipline",
  "Defensive Discipline",
];

export const DRILL_CATEGORIES = [
  { value: "warm_up", label: "Warm-Up" },
  { value: "skill_work", label: "Skill Work" },
  { value: "scrimmage", label: "Scrimmage" },
  { value: "cool_down", label: "Cool-Down" },
];

export const DRILL_DIFFICULTIES = [
  { value: "beginner", label: "Beginner" },
  { value: "intermediate", label: "Intermediate" },
  { value: "advanced", label: "Advanced" },
];
